import type { StayDayStatus } from "@/lib/daycare-hotel/stayDays";

export interface StayDayConflictCandidate {
  stayDate: string;
  status: StayDayStatus | string;
}

/** Dias que já não ocupam vaga: encerrados, cancelados ou faltados. */
const RELEASED_STATUSES = new Set(["checked_out", "cancelled", "no_show"]);

/**
 * Com o dia materializado, conflito é comparação de igualdade — não há mais
 * intervalo a expandir.
 */
export function isStayDayConflict(day: StayDayConflictCandidate, date: string): boolean {
  if (RELEASED_STATUSES.has(String(day.status).trim().toLowerCase())) return false;
  return day.stayDate === date;
}
